export const reportNoteState = {
  values: {
    reportNotes: [{ placeholder: "", content: [] }],
  },
  // reportNotes: [],
  errors: {},
  isValid: false,
  isReportNoteEditable: false,
  reportNotesTouched: false,
  hasReportNoteEditAccess: false,
  isExplicitReportNoteEditable: false,
  isReportNoteSubmitting: false,
  isReportNoteSubmittingAndProcessing: false,
  showEditDiagnosisModal: false,
  billingDiagnosisCodes: [],
  evokeReportNotes: [],
  originalEvokeReportNotes: [],
  saveWithProcess: false,
  showSuggestionModal: false,
  reportNoteSuggestions: [],
  displayPopup: false,
};
